import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { filter } from 'rxjs/operators';
import { CMSResolver } from '../../providers/cms.resolver';
import { ChipsService } from './chips.service';

@Component({
  selector: 'app-chips',
  styleUrls: ['./chips.component.scss'],
  templateUrl: './chips.component.html'
})

export class ChipsComponent implements OnInit {
  chips$: Observable<any>;
  constructor(
    protected router: Router,
    protected chipsService: ChipsService
  ) {
    this.chips$ = this.chipsService.chips$
  }
  ngOnInit() {
  }
  chipClick(chip) {
    this.router.navigate([chip.routerLink]);
    this.chipsService.setChips(undefined);
  }
}
